import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SupportTicket, AdminUser } from '../../core/models/admin.models';

@Component({
  selector: 'app-ticket-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './ticket-form.component.html'
})
export class TicketFormComponent implements OnInit {
  @Input() ticketData: SupportTicket | null = null;
  @Input() users: AdminUser[] = [];
  @Output() save = new EventEmitter<Partial<SupportTicket>>();
  @Output() cancel = new EventEmitter<void>();

  form!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.form = this.fb.group({
      user_id: [null, Validators.required],
      subject: [this.ticketData?.subject || '', Validators.required],
      description: [this.ticketData?.description || '', Validators.required],
      priority: [this.ticketData?.priority || 'medium', Validators.required]
    });
  }

  submit() {
    if (this.form.valid) {
      this.save.emit(this.form.value);
    } else {
      this.form.markAllAsTouched();
    }
  }
}
